import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/content.scss';
import Color from '@tool/color';
import { newRate } from '@tool/index';
import Top from './top/index';
import Industry from './industry/index';
import Rival from './rival/index';
import Salary from './salary/index';
import ChangeItem from './change-item';
import moChange from './store/change';

interface IProps {}
interface IState {}

const Content = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { modelList } = moChange;

  const emeu: any = {
    industry: <Industry />,
    rival: <Rival />,
    salary: <Salary />,
  };

  useEffect(() => {
    // initContent();
    return () => {};
  }, []);

  return (
    <section className="content-011">
      <Top />
      <section className="content-015">
        {!isEmpty(modelList) ? emeu[modelList[0].code] : <Industry />}
        {!isEmpty(modelList) ? emeu[modelList[1].code] : <Rival />}
        {!isEmpty(modelList) ? emeu[modelList[2].code] : <Salary />}
      </section>
      <ChangeItem />
    </section>
  );
};

export default observer(Content);
